import {useQuery} from 'react-query';
import {getCashBackCardDetail} from './getCashBackCardDetail';

const useGetCashBackCardDetail = (cashBackGuid?: string) => {
  return useQuery(
    ['get-cash-back-card-detail', cashBackGuid],
    () => getCashBackCardDetail(cashBackGuid!),
    {enabled: Boolean(cashBackGuid)},
  );
};

export default useGetCashBackCardDetail;
